import React, { useState, useEffect, useRef } from "react";
import { compose } from "redux";
import enhancer from "./validator";
import Select from 'react-select';

const UserForm = props => {

    const selectCompany = useRef('');
    const [loadingCompany, setLoadingCompany] = useState(false);

    const {
        handleChange,
        handleBlur,
        errors,
        touched,
        submitCount,
        onSubmit,
        values,
        action,
        setFieldValue
    } = props;

    const Error = props => {
        const field1 = props.field;
        if ((errors[field1] && touched[field1]) || submitCount > 0) {
            return (
                <span className={props.class ? props.class : "error-msg"}>
                    {errors[field1]}
                </span>
            );
        } else {
            return <span></span>;
        }
    };

    const handleSubmit = () => {
        let { values, isValid, handleSubmit } = props;
        if (isValid) {
            onSubmit(values, action);
        }
        handleSubmit();
    };

    function useFetch(url) {
        const [data, setData] = useState([]);
        async function fetchUrl() {
          const response = await fetch(url);
          const json = await response.json();
          setData(json);
        }
        useEffect(() => {
          fetchUrl();
        }, []);
        return data;
    }
    const companies = useFetch('/service/companies');

    useEffect(() => {
        if(values.company && !loadingCompany){
            selectCompany.current.select.setValue(values.company)
            setLoadingCompany(true);
        }
    },[values.company])
    
    return (
        <div>
            <form>
                <div className="form-group">
                    <label className="fs-16 medium-text">Cihaz Adı</label>
                    <input
                        type="text"
                        className="form-control react-form-input"
                        id="name"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.name}
                        placeholder="İsim"
                    />
                    <Error field="firstname" />
                </div>

                <div className="form-group">
                    <label className="fs-16 medium-text">Kimlik numarası</label>
                    <input
                        type="text"
                        className="form-control react-form-input"
                        id="identity"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.identity}
                        placeholder="Kimlik numarası"
                    />
                    <Error field="identity" />
                </div>

                <div className="form-group">
                    <label className="fs-16 medium-text">Cihaz Modeli</label>
                    <select 
                        className="form-control react-form-input"
                        id='deviceModel'
                        value = {values.deviceModel}
                        onChange = {handleChange}
                        >
                            <option value='Belirtilmemiş'>Belirtilmemiş</option>
                            <option value='Raspberry Pi 3'>Raspberry Pi 4</option>
                            <option value='Raspberry Pi 2'>Raspberry Pi 3</option>
                            <option value='Raspberry Pi'>Raspberry Pi 2</option>
                    </select>
                </div>


                <div className="form-group">
                    <div className="form-group">
                    <label className="fs-16 medium-text">Pozisyon</label>

                    <Select
                        placeholder="select options"
                        onChange={value => setFieldValue('company', value)}
                        ref={selectCompany}
                        id="company"
                        name="company"
                        options={
                            companies.map(company => {
                                return { value : company._id, label: company.name }
                            })
                        }
                    />
                    <Error field="deviceCompany" />
                    </div>
                </div>


                <div className="form-group">
                    <label className="fs-16 medium-text">Publish Kodu</label>
                    <input
                        type="text"
                        className="form-control react-form-input"
                        id="publishName"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.publishName}
                        placeholder="Publish Kodu"
                        disabled
                    />
                    <Error field="publishName" />
                </div>

                <div className="form-group" >
                    <label className="fs-16 medium-text">Subscribe Kodu</label>
                    <input
                        type="text"
                        className="form-control react-form-input"
                        id="subscribeName"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.subscribeName}
                        placeholder="Subscribe Kodu"
                        disabled
                    />
                    <Error field="subscribeName" />
                </div>
                
                <div>
                    <button
                        type="button"
                        className="c-btn c-info form-button fs-16 demi-bold-text"
                        style={{ maxWidth: "125px" }}
                        onClick={() => handleSubmit()}
                    >
                        Submit
                    </button>
                </div>
            </form>
        </div>
    );
};

export default compose(enhancer)(UserForm);
